import { Link } from 'react-router-dom'
import { LandingButton, Reveal } from '../primitives'

const LINKS = [
  { label: 'Pricing', href: '/pricing' },
  { label: 'About', href: '/about' },
  { label: 'Docs', href: '/docs' },
  { label: 'Contact', href: '/contact' },
  { label: 'Terms', href: '/terms' },
  { label: 'Privacy', href: '/privacy' },
]

export function ClosingSection() {
  return (
    <section className="py-[var(--l-section)]">
      <div className="l-frame">
        <Reveal as="h2" className="l-lead max-w-[24em] font-normal">
          Plan the next one with your crew. It's free to start.
        </Reveal>
        <Reveal delay={60} className="mt-6 flex flex-wrap items-center gap-x-6 gap-y-3">
          <LandingButton to="/signup">Start planning free</LandingButton>
          <Link to="/join" className="l-link l-link--always l-small">
            Join an existing trip
          </Link>
        </Reveal>
      </div>
    </section>
  )
}

export function LandingFooter() {
  return (
    <footer className="pb-6">
      <div className="l-frame l-small grid gap-2 md:grid-cols-[1fr_auto_1fr] md:items-baseline md:gap-6">
        <p className="l-soft">Trip planning for overlanding crews</p>
        <ul className="flex flex-wrap gap-x-5 gap-y-1">
          {LINKS.map((link) => (
            <li key={link.label}>
              <Link to={link.href} className="l-link">
                {link.label}
              </Link>
            </li>
          ))}
        </ul>
        <p className="l-soft md:text-right">© {new Date().getFullYear()}</p>
      </div>
    </footer>
  )
}
